var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.myPermissions[_vm.permission])?_c('button',_vm._g(_vm._b({},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }